<template>
	<div v-if="!isLoggedIn" class="login-form p-5">
		<h3>{{ title }}</h3>
		<span>Logga in eller skapa enkelt en ny medlemsprofil för att komma vidare.</span>
		<member-form :showCloseButton="false" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { error } from 'utils';
export default {
	layoutOptions: {
		leftCol: true,
	},
	data () {
		return {
			title : '',
		};
	},
	mounted () {
		this.redirectIfLoggedIn();
	},
	methods: {
		redirectIfLoggedIn () {
			if (this.isLoggedIn && this.currentUserId) {

				const n = this.$route.path.lastIndexOf('/');
				const component = this.$route.path.substring(n + 1);

				if (this.memberShortcuts[component]) {
					const route = this.memberShortcuts[component];
					this.$router.push(route);
				} else {
					error(404, 'Sidan kan inte hittas :(')(this);
				}
			}
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			currentUserId: 'user/currentUserId',
		}),
		memberShortcuts () {
			return {
				offers: {
					name: 'member.offers',
					title: 'Medlemserbjudanden',
					params: {
						id: this.currentUserId,
					},
					query: {
						showHighlights: (this.$route.query.showHighlights === true) ? true : false,
					},
				},
				orders: {
					name: 'member.orders',
					title: 'Beställningar',
					params: {
						id: this.currentUserId,
					},
				},
				benefits: {
					name: 'member.benefits',
					title: 'Medlemsförmåner',
					params: {
						id: this.currentUserId,
					},
				},
				wishlists: {
					name: 'member.wishlists',
					title: 'Önskelista',
					params: {
						id: this.currentUserId,
					},
				},
				payments: {
					name: 'member.payments',
					title: 'Delbetalningar',
					params: {
						id: this.currentUserId,
					},
				},
				profile: {
					name: 'member.profile',
					title: 'Profilinställningar',
					params: {
						id: this.currentUserId,
					},
				},
				achievements: {
					name: 'member.achievements',
					title: 'Achievements',
					params: {
						id: this.currentUserId,
					},
				},
				statistics: {
					name: 'member.statistics',
					title: 'Statistik',
					params: {
						id: this.currentUserId,
					},
				},
				avatar: {
					name: 'member.avatar',
					title: 'Min avatar',
					params: {
						id: this.currentUserId,
					},
				},
				supplydrop: {
					name: 'member.supply-drop',
					title: 'Supply drop',
					params: {
						id: this.currentUserId,
					},
				},
				knighthood: {
					name: 'member.knighthood',
					title: 'Knighthood',
					params:{
						id: this.currentUserId,
					}
				},
				toplist: {
					name: 'member.toplist',
					title: 'Topplista',
					params: {
						id: this.currentUserId,
					},
				},
				game: {
					name: 'member.game',
					title: 'World of Webhallen',
					params: {
						id: this.currentUserId,
					},
				},
			};
		},
	},
	watch: {
		currentUserId () {
			this.redirectIfLoggedIn();
		},
	},
};
</script>
